import { atom, useAtomValue, useSetAtom } from 'jotai';

import type { SeedPost } from './seed-post-store';

export type PendingDiscoveryAction =
  | {
      id: string;
      sessionId: string;
      type: 'prompt';
      message: string;
    }
  | {
      id: string;
      sessionId: string;
      type: 'commonality';
      seedPosts: SeedPost[];
    };

const pendingDiscoveryActionsAtom = atom<PendingDiscoveryAction[]>([]);

export function usePendingDiscoveryActions(sessionId: string) {
  const pendingActions = useAtomValue(pendingDiscoveryActionsAtom);

  return pendingActions.filter((action) => action.sessionId === sessionId);
}

export function usePendingDiscoveryActionActions() {
  const setPendingActions = useSetAtom(pendingDiscoveryActionsAtom);

  return {
    addPendingAction: (action: PendingDiscoveryAction) => {
      setPendingActions((currentActions) => [action, ...currentActions]);
    },
    removePendingAction: (actionId: string) => {
      setPendingActions((currentActions) =>
        currentActions.filter((action) => action.id !== actionId),
      );
    },
  };
}
